import React, { Component } from 'react'
import Logo from '../logos/trapink'
import Social from '../social'

class Footer extends Component {
  render() {
    const year = (new Date()).getFullYear();

    return (
      <footer className="site-footer container container--grid">
        <div className="row">
          <div className="col col--10 col--push-1 col--md-4 col--md-push-4">
            <Logo className="site-footer__logo" />
            <div className="site-footer__locations">
              <div className="location">
                <h4 className="location__header">West Bradenton</h4>
                <span className="location__phone"><a href="tel:+19417301223">(941) 730-1223</a></span>
                <span className="location__address"><a href="https://www.google.com/maps/place/Trap+Ink+Tattoos+%26+Piercings/@27.44165,-82.5894737,17z/data=!3m1!4b1!4m5!3m4!1s0x88c33fdc221c451d:0x1f86b906287a1d5e!8m2!3d27.44165!4d-82.587285" target="_blank" rel="noopener noreferrer">5615 26th St W Bradenton, FL</a></span>
              </div>
              <div className="location">
                <h4 className="location__header">East Bradenton</h4>
                <span className="location__phone"><a href="tel:+19419812234">(941) 981-2234</a></span>
                <span className="location__address"><a href="https://www.google.com/maps/place/3120+53rd+Ave+E,+Bradenton,+FL+34203/@27.4466976,-82.5268422,17z/data=!3m1!4b1!4m6!3m5!1s0x88c33dd69cee48df:0x2e36b0d9ca5032b0!8m2!3d27.4466976!4d-82.5242673!16s%2Fg%2F11gxy5l1zb?entry=ttu" target="_blank" rel="noopener noreferrer">3120 53rd Ave E Bradenton, FL</a></span>
              </div>
            </div>
            <Social facebook="trapinktattoos" instagram="trapinktattoos" />
            <span className="site-footer__copyright">
              Copyright © { year } - Trap Ink Tattoos. Designed and Developed by <a href="http://www.itsmedrew.com" target="_blank" rel="noopener noreferrer">Drew Roberts.</a>
            </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js